import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import OrderFontList from '../entities/order-font-list'
import createdata from '@/store/entities/create-order'
import appconst from '@/lib/appconst';
import UserOrderStatistics from '@/store/entities/user-order-statistics';


interface FontOrderState extends ListState<OrderFontList> {
    orderInfo: createdata,

}

class FontOrderMutations extends ListMutations<OrderFontList>{

}
class FontOrder extends ListModule<FontOrderState, any, OrderFontList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<OrderFontList>(),
        loading: false,
        orderInfo: new createdata(),
        orderStatus: null
    }
    actions = {
        async getAll(context: ActionContext<FontOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontOrder/GetOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<OrderFontList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async createOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/CreateOrder', payload.data);
        },
       async updateOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/UpdateOrder', payload.data);
        },
        
        async cancelOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/CancelOrder?id=' + payload.data.id);
        },
        async urgentOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/urgentOrder?id=' + payload.data.id);
        },
        async normalOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontOrder/NormalOrder?id=' + payload.data.id);
        },
        async getOrder(context: ActionContext<FontOrderState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/FrontOrder/GetOrderInfo', { params: payload.data });
            context.state.orderInfo =(reponse.data.result as createdata);
        },
        async getOrderStatistics(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontOrder/GetOrderStatistics', payload.data);
            return rep.data.result as UserOrderStatistics;
        },
     
    };
    mutations = {
        setCurrentPage(state: FontOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FontOrderState, pagesize: number) {
            state.pageSize = pagesize;
        },
        getPdf(state: FontOrderState, data: any) {
            if (data.pdfGuid && data.pdfGuid.length > 1) {
                window.open(appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + data.pdfGuid + "&id=" + (data.userId ? data.userId : abp.session.userId) + "&orderNumber=" + data.orderNumber);
            }
        },
         getPdfbyte(state: FontOrderState, data: any) {
             window.open(appconst.remoteServiceBaseUrl + "api/File/GetPdfbyte?barCode=" + data.barCode + "&shelfPosition=" + data.shelfPosition + "&imageUrl=" + data.imageUrl + (data.isRotate != null ? "&isRotate=" + data.isRotate : ""));
        },
        getPdfUrl(state: FontOrderState, data: any) {
            if (data.isLable) {
                data.url = appconst.remoteServiceBaseUrl + "api/File/GetLablePdfbyte?barCode=" + data.barCode + "&shelfPosition=" + data.shelfPosition + "&imageUrl=" + data.imageUrl + "&lableInfo=" + data.lableInfo + (data.isRotate != null ? "&isRotate=" + data.isRotate : "");
            } else {
                data.url = appconst.remoteServiceBaseUrl + "api/File/GetPdfbyte?barCode=" + data.barCode + "&shelfPosition=" + data.shelfPosition + "&imageUrl=" + data.imageUrl + (data.isRotate != null ? "&isRotate=" + data.isRotate : "");
            }
        },
        getZDYPdfUrl(state: any, data: any) {
            if (data.pdfdata == false) {
                data.url = appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + data.pdfGuid + "&id=" + (data.userId ? data.userId : abp.session.userId) + "&orderNumber=" + data.orderNumber;
            } else {
                data.url = appconst.remoteServiceBaseUrl + "api/File/GetZDYPdf?guid=" + data.pdfGuid + "&userId=" + data.userId + "&heightPercentage=" + data.heightPercentage + "&infos=" + encodeURIComponent(data.infos);
            }
        }
    }
}

const fontOrder = new FontOrder();
export default fontOrder;